/**
 * create by Taobao dev team 19/1/2018
 */
import React, {Fragment} from 'react';

import {
    Row, Col, Collapse,
    Empty, Button, Spin, Alert
} from 'antd';
import * as AntdIcon from "@ant-design/icons"

import ListAddressModal from "./ListAddressModal";
import {withNamespaces} from "react-i18next";
import UserServices from "../../services/user.service";

const Panel = Collapse.Panel;

class DeliveryAddress extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
        }
    }

    /**
     * lấy ra danh sách trạng thái của package
     */
    checkWareHouse = () => {
        const {selectedAddress = {}} = this.state;
        UserServices.checkWareHouse(selectedAddress.id, (err, res, headers) => {
            if (err === null) {
                this.setState({
                    checkWareHouse: res,
                });
            }
        });
    };

    /**
     * mở modal chọn address
     */
    toggleModalAddress = () => {
        this.setState({modalAddressStatus: !this.state.modalAddressStatus})
    };

    /**
     * mở modal tạo address
     */
    toggleModalCreateAddress = () => {
        this.setState({modalCreateAddressStatus: !this.state.modalCreateAddressStatus})
    };

    /**
     * thay đổi address
     * @param address
     * @param cb
     */
    changeAddressSelected = (address, cb) => {
        const {updateDraftOrder, updateLoadingStatus} = this.props;
        this.setState({
            selectedAddress: address,
            isLoading: false
        }, () => {
            if (address) {
                this.checkWareHouse()
                updateDraftOrder({address: address.id}, cb)
            } else {
                updateLoadingStatus(false)
            }
        })
    };

    /**
     * ẩn hiện modal
     */
    showModal = () => {
        const {selectedAddress} = this.state;
        if (selectedAddress) {
            this.toggleModalAddress();
        } else {
            this.toggleModalCreateAddress()
        }
    };

    /**
     * render header của panel
     */
    renderPanelHeader = () => {
        return (
            <div className={'panel-address-header _deliveryAdressTitle'}>
                <h4>{this.props.t('customerAddress.delivery_address')}</h4>
            </div>
        )
    };

    render() {
        const {isUpdateDraftOrder, defaultAddress, className, t} = this.props;
        let {
            selectedAddress, modalCreateAddressStatus,
            modalAddressStatus, dataItem,
            checkWareHouse = {}
        } = this.state;
        return (
            <Spin spinning={isUpdateDraftOrder} indicator={<AntdIcon.Loading3QuartersOutlined type="loading" style={{ fontSize: 24 }} spin />}>
                <React.Fragment>
                    <Collapse accordion defaultActiveKey={['1']} className={`sidebar deliveryaddress position-re ${className || ''}`}>
                        <Panel header={this.renderPanelHeader()} key={1}>
                            {selectedAddress ? (
                                <Fragment>
                                    <div className={'deliveryaddress__box pd20'}>
                                        <Row>
                                            <Col md={24} className={'_address-fullname deliveryaddress__name position-re txt-size-h7 robotobold txt-color-black mgbt15 break-word'}>{selectedAddress.fullname} <span className="normal">{selectedAddress.addressName && `(${selectedAddress.addressName})`}</span></Col>
                                        </Row>
                                        <Row className={'mgbt5'}>
                                            <Col md={3} className={'txt-size-h7 txt-color-gray'}><AntdIcon.HomeOutlined type="home" /></Col>
                                            <Col md={21} className={'_address-detail txt-color-black txt-size-h7 robotoregular wordbreakall'}>{selectedAddress.detail}</Col>
                                        </Row>

                                        <Row className={'mgbt5'}>
                                            <Col md={3} className={'txt-size-h7 txt-color-gray'}><AntdIcon.PhoneOutlined type="phone" /></Col>
                                            <Col md={21} className={'_address-phone txt-color-black txt-size-h7 robotoregular'}>{selectedAddress.phone}</Col>
                                        </Row>

                                        <Row className={'mgbt5'}>
                                            <Col md={3} className={'txt-size-h7 txt-color-gray'}><AntdIcon.GlobalOutlined type="global" /></Col>
                                            <Col md={21} className={'_address-location-display txt-color-black txt-size-h7 robotoregular'}>{selectedAddress.location.display}</Col>
                                        </Row>
                                        {
                                            selectedAddress.note && <Row className={'mgbt5'}>
                                                <Col md={3} className={'txt-size-h7 txt-color-gray'}><AntdIcon.MessageOutlined type="message" /></Col>
                                                <Col md={21} className={'_address-note txt-color-black txt-size-h7 robotoregular break-word'}>{selectedAddress.note}</Col>
                                            </Row>
                                        }
                                        <a className={'_btn-select-address deliveryaddress__edit position-ab txt-size-h8 txt-color-blue'} onClick={this.showModal}>{t('customerAddress.btn_edit')}</a>
                                    </div>
                                </Fragment>
                                ) : (
                                <Empty
                                    image={require('../../resources/images/empty-image.png')}
                                    description={
                                        <span>
                                            {t('customerAddress.no_address')}
                                        </span>
                                    }
                                >
                                    <Button className="_btnCreateAddress" type="primary" onClick={() => this.showModal()}>{t('customerAddress.create_address')}</Button>
                                </Empty>
                            )}
                        </Panel>
                    </Collapse>

                    {
                        selectedAddress && !checkWareHouse.inWarehouseArea
                            ? <Alert
                                className="mgbt10 mgt10"
                                message={<span className="bold txt-size-h6">{t('order.notification')}</span>}
                                description={<div dangerouslySetInnerHTML={{__html: t('message.warning_warehouse', {warehouse: checkWareHouse.warehouse})}}/>}
                                type="warning"
                                showIcon
                                closable
                            />
                            :
                            null
                    }

                    <ListAddressModal
                        t={t}
                        defaultAddress={defaultAddress}
                        isUpdateDraftOrder={isUpdateDraftOrder}
                        selectedAddress={selectedAddress}
                        changeAddressSelected={this.changeAddressSelected}
                        toggleListAddressModal={this.toggleModalAddress}
                        modalStatus={modalAddressStatus}
                        toggleCreateModal={this.toggleModalCreateAddress}
                        modalCreateStatus={modalCreateAddressStatus}
                        modalCreateAddressStatus={this.state.modalCreateAddressStatus}
                        dataItem={dataItem}
                    />
                </React.Fragment>
            </Spin>
        )
    }
}

export default withNamespaces('translation')(DeliveryAddress);